import { CheckCircle, Phone, Eye, Gift } from 'lucide-react'

export default function ThankYouScreen() {
  return (
    <div className="w-full max-w-md mx-auto px-4">
      <div className="bg-white rounded-xl shadow-lg p-6 sm:p-8 text-center">
        <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-green-50">
          <CheckCircle className="h-8 w-8 text-green-600" />
        </div>

        <h1 className="text-2xl font-bold text-gray-900">You're on the list.</h1>
        <p className="mt-3 text-sm leading-relaxed text-gray-500">
          We'll reach out to you personally before TaxHive opens to anyone else.
          You're not just early — you're shaping what we build.
        </p>

        <div className="mt-8 rounded-lg bg-gray-50 p-5 text-left">
          <p className="mb-3 text-sm font-semibold text-gray-900">What happens next:</p>
          <ul className="space-y-3">
            <li className="flex items-start gap-3 text-sm text-gray-600">
              <Phone className="mt-0.5 h-4 w-4 flex-shrink-0 text-blue-500" />
              We'll call or email you within 3 business days
            </li>
            <li className="flex items-start gap-3 text-sm text-gray-600">
              <Eye className="mt-0.5 h-4 w-4 flex-shrink-0 text-blue-500" />
              You'll get to review the product before public launch
            </li>
            <li className="flex items-start gap-3 text-sm text-gray-600">
              <Gift className="mt-0.5 h-4 w-4 flex-shrink-0 text-blue-500" />
              Early reviewers get 6 months free — no catch
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}
